const tenantID = 'biozone-world';
const tenantName = 'BIOZONE World';
const loaderImage = 'biozone-world-white.svg';
const headerImage = 'biozone-world-white.svg';

export { tenantID, tenantName, loaderImage, headerImage };
